<div class="main-controls">
  <div class="main-controls__left">
    <div class="control-button-outer microphone-control">
      <stusan-control-button [type]="(isMobileView$ | async) ? 'small' : 'normal'"
                             [ariaLabel]="isAudioEnabled ? 'Mute' : 'Unmute'"
                             [tooltipText]="isAudioEnabled ? 'Disable microphone' : 'Enable microphone'"
                             (click)="toggleMic()"
                             [class.wait]="micMuting$ | async">
        <stusan-toggle-icon
          [label]="'Mic'"
          [labelColor]="isAudioEnabled ? 'default' : 'enabled'"
          [icon]="isAudioEnabled ? 'menu-mic-on' : 'menu-mic-off'"
          [hover]="isAudioEnabled"
          [class.activity]="isAudioEnabled && isVoiceActive"
        ></stusan-toggle-icon>
      </stusan-control-button>
    </div>

    <div class="control-button-outer camera-control">
      <stusan-control-button [type]="(isMobileView$ | async) ? 'small' : 'normal'"
                             [ariaLabel]="isVideoEnabled ? 'Stop Cam' : 'Start Cam'"
                             (click)="toggleCam()"
                             [tooltipText]="isVideoEnabled ? 'Disable camera': 'Enable camera'"
                             [class.wait]="cameraMuting$ | async"
      >
        <stusan-toggle-icon
          [label]="'Cam'"
          [labelColor]="isVideoEnabled ? 'default' : 'enabled'"
          [icon]="isVideoEnabled ? 'menu-cam-on' : 'menu-cam-off'"
          [hover]="isVideoEnabled"
        ></stusan-toggle-icon>
      </stusan-control-button>
    </div>
    <div class="rec-control">
      <thevatra-recording-control [active]="recordingEnabled"
                                  *ngIf="customConfig.isRecordingEnabled"
      ></thevatra-recording-control>
    </div>
<!--    <div class= "control-button-outer control-button-outer&#45;&#45;raise raise-control">-->
<!--      <stusan-control-button tooltipText="Raise hand"-->
<!--                             (click)="toggleRaiseHand()"-->
<!--                             [ariaLabel]="(this.stateService.isHandRaised$ | async) ? 'Raise hand' : 'Hide hand'">-->
<!--        <stusan-toggle-icon-->
<!--          [label]="'Hand'"-->
<!--          [icon]="'menu-hand'"-->
<!--          [state]="(this.stateService.isHandRaised$ | async)">-->
<!--        </stusan-toggle-icon>-->
<!--      </stusan-control-button>-->
<!--    </div>-->
  </div>
  <div class="main-controls__center">
    <svg width="140" height="79" viewBox="0 0 140 79" class="finish-call-bg" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 0.5H0.5V1V78V78.5H1H141H141.5V78V1V0.5H141H139.9H139.879L139.857 0.501827C132.84 1.10327 127.387 2.13446 122.862 4.41606C118.321 6.70577 114.757 10.2325 111.47 15.7439L111.461 15.7597L111.453 15.7762C111.365 15.9512 111.254 16.1306 111.126 16.3351C111.126 16.3351 111.126 16.3352 111.126 16.3353L111.12 16.3451C111.002 16.5336 110.87 16.7448 110.761 16.9608C106.108 24.8654 100.836 33.7618 94.4314 40.7497C88.0269 47.7375 80.5476 52.7529 71.4932 53H70.5068C61.4524 52.7529 53.973 47.7375 47.5558 40.7493C41.1387 33.7611 35.842 24.8648 31.1388 16.9594C31.0297 16.7439 30.8979 16.5331 30.7801 16.3445L30.7741 16.335C30.6465 16.1308 30.5347 15.9512 30.4471 15.7762L30.4396 15.7612L30.4312 15.7468C27.1937 10.233 23.6286 6.70559 19.0746 4.41581C14.5373 2.1344 9.05964 1.10325 2.0427 0.501827L2.02139 0.5H2H1Z"
        fill="var(--border-color)" stroke="var(--border-color)" />
      <path
        d="M1 1H0V80H142V1H140.9C126.9 2.19995 118.4 5.1001 111.9 16C111.8 16.2 111.675 16.3999 111.55 16.6001C111.425 16.8 111.3 17 111.2 17.2C101.9 33 90 53 71.5 53.5H70.5C52 53 40.1001 33 30.7002 17.2C30.5 16.8 30.2002 16.3999 30 16C23.6001 5.1001 15 2.19995 1 1Z"
        fill="var(--background-color-controls)" />
    </svg>

    <button class="finish-call" (click)="handleEndCall()" automationId="finishCallButton">
      <stusan-icon class="finish-call-icon" icon="finish-call" style="width: 24px; height: 24px;"></stusan-icon>
      <stusan-icon class="exit-room-icon" icon="exit-room" style="width: 24px; height: 24px; margin-left: 10px;"></stusan-icon>
    </button>
  </div>

  <div class="main-controls__center_mobile">
    <svg class="finish-call-bg" width="140" height="64" viewBox="0 0 140 64" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 0.5H0.5V1V78V78.5H1H141H141.5V78V1V0.5H141H139.9H139.879L139.857 0.501827C132.84 1.10327 127.387 2.13446 122.862 4.41606C118.321 6.70577 114.757 10.2325 111.47 15.7439L111.461 15.7597L111.453 15.7762C111.365 15.9512 111.254 16.1306 111.126 16.3351C111.126 16.3351 111.126 16.3352 111.126 16.3353L111.12 16.3451C111.002 16.5336 110.87 16.7448 110.761 16.9608C106.108 24.8654 100.836 33.7618 94.4314 40.7497C88.0269 47.7375 80.5476 52.7529 71.4932 53H70.5068C61.4524 52.7529 53.973 47.7375 47.5558 40.7493C41.1387 33.7611 35.842 24.8648 31.1388 16.9594C31.0297 16.7439 30.8979 16.5331 30.7801 16.3445L30.7741 16.335C30.6465 16.1308 30.5347 15.9512 30.4471 15.7762L30.4396 15.7612L30.4312 15.7468C27.1937 10.233 23.6286 6.70559 19.0746 4.41581C14.5373 2.1344 9.05964 1.10325 2.0427 0.501827L2.02139 0.5H2H1Z"
        fill="var(--border-color)" stroke="var(--border-color)" />
      <path
        d="M1 1H0V80H142V1H140.9C126.9 2.19995 118.4 5.1001 111.9 16C111.8 16.2 111.675 16.3999 111.55 16.6001C111.425 16.8 111.3 17 111.2 17.2C101.9 33 90 53 71.5 53.5H70.5C52 53 40.1001 33 30.7002 17.2C30.5 16.8 30.2002 16.3999 30 16C23.6001 5.1001 15 2.19995 1 1Z"
        fill="var(--background-color-controls)" />
    </svg>

    <button class="finish-call" (click)="handleEndCall()">
      <stusan-icon class="finish-call-icon" icon="finish-call" style="width: 30px; height: 30px;"></stusan-icon>
      <stusan-icon class="exit-room-icon" icon="exit-room" style="width: 30px; height: 30px; margin-left: 10px;"></stusan-icon>
    </button>
  </div>

  <div class="main-controls__right">
    <div class="right-controls__left-side">
      <div *ngIf="!stateService.isCamBanned && isDesktopPlatform" class="control-button-outer share-control">
        <thevatra-screen-share-control></thevatra-screen-share-control>
      </div>
      <div *ngIf="!stateService.isCamBanned && isDesktopPlatform" class="control-button-outer share-zwift">
        <thevatra-zwift-share-control></thevatra-zwift-share-control>
      </div>
      <div class= "control-button-outer control-button-outer--invite-participant invite-control"
           *ngIf="(this.isInviteParticipantControlShown$ | async) === true"
      >
        <div *ngIf="this.isInviteParticipantShown | async" class="invite-participant">
          <span>Link: {{ roomUrl }}</span>
          <button class="invite-participant__copy" (click)="copyRoomUrl()" aria-label="Copy room url">
            <stusan-icon icon="copy" style="width: 24px; height: 24px; fill: #FC8B01;"></stusan-icon>
          </button>
        </div>

        <div *ngIf="this.isInviteParticipantSuccessShown | async"
             class="invite-participant invite-participant--success">
          <span>Link copied to clipboard</span>
          <stusan-icon icon="check" style="width: 17px; height: 17px; fill: #675A91;"></stusan-icon>
        </div>

        <stusan-control-button tooltipText="Invite participants"
                               [isTooltipDisabled]="(this.isInviteParticipantShown | async) === true"
                               (click)="toggleInviteParticipant()">
          <stusan-toggle-icon
            [label]="'Invite'"
            [icon]="'menu-invite'"
            [state]="(this.isInviteParticipantShown | async)"
          ></stusan-toggle-icon>
        </stusan-control-button>
      </div>
    </div>
    <div class="right-controls__right-side">
      <div class="control-button-outer feedback-control">
        <a [attr.href]="this.customConfig.feedbackUrl"
           class="feedback-control__link"
           target="_blank">
          <stusan-control-button [type]="(isMobileView$ | async) ? 'small' : 'normal'"
                                 [ariaLabel]="'Send feedback'">
            <stusan-toggle-icon
              [label]="'Feedback'"
              [icon]="'menu-feedback'">
            </stusan-toggle-icon>
          </stusan-control-button>
        </a>
      </div>
      <div class="control-button-outer settings-control">
        <stusan-control-button #settingsButton
                               [type]="(isMobileView$ | async) ? 'small' : 'normal'"
                               [ariaLabel]="(this.stateService.isSettingsShown$ | async) ? 'Show settings' : 'Hide settings'"
                               (click)="toggleSettings()">
          <stusan-toggle-icon
            [label]="'Settings'"
            [icon]="'menu-settings'"
            [state]="(this.stateService.isSettingsShown$ | async)">
          </stusan-toggle-icon>
        </stusan-control-button>
      </div>
      <div class="control-button-outer chat-control"
           *ngIf="!customConfig.isProfileEnabled"
           [ngClass]="{'chat-control--notify': (notify$ | async),
         'chat-control--loading': (loading$ | async),
         'notification': (notify$ | async) && (this.stateService.isChatShown$ | async) !== true
         }"

      >
        <span *ngIf="(notify$ | async) && (this.stateService.isChatShown$ | async) !== true" class="badge"></span>
        <stusan-control-button [ariaLabel]="(this.stateService.isChatShown$ | async) ? 'Show chat' : 'Hide chat'"
                               (click)="onLoginAnonymousClick($event)"
        >
          <stusan-toggle-icon
            [label]="'Chat'"
            [icon]="'menu-chat'"
            [state]="(this.stateService.isChatShown$ | async)"
          >
          </stusan-toggle-icon>
        </stusan-control-button>
      </div>
      <div class="control-button-outer participants-control"
           *ngIf="!customConfig.isLikesEnabled"
      >
        <stusan-control-button [ariaLabel]="(this.stateService.isParticipantsShown$ | async) ? 'Show participants' : 'Hide participants'"
                               (click)="toggleParticipants()">
          <stusan-toggle-icon
            [label]="'Participants'"
            [icon]="'menu-participants'"
            [state]="(this.stateService.isParticipantsShown$ | async)"
          >
          </stusan-toggle-icon>
        </stusan-control-button>
      </div>
      <div class="control-button-outer you-control"
           *ngIf="customConfig.isProfileEnabled"
      >
        <stusan-control-button (click)="toggleProfile()"
                               #profileButton
        >
          <div *ngIf="!this.auth.currentUser?.photoURL; else avatar">
            <stusan-toggle-icon
              [label]="'You'"
              [icon]="'menu-profile'"
            >
            </stusan-toggle-icon>
          </div>
          <ng-template #avatar>
          <span class="avatar">
            <img [attr.src]="this.auth.currentUser?.photoURL"
                 class="avatar__pic"
                 referrerpolicy="no-referrer"
            >
            <span class="avatar__label">You</span>
          </span>
          </ng-template>
        </stusan-control-button>
      </div>
      <div class="control-button-outer menu-control">
        <stusan-control-button #menuButton
                               [type]="(isMobileView$ | async) ? 'small' : 'normal'"
                               [ariaLabel]="(this.stateService.isMobileMenuShown$ | async) ? 'Open menu' : 'Close menu'"
                               (click)="toggleMobileMenu()"
        >
          <stusan-toggle-icon
            [label]="'Menu'"
            [icon]="'menu-burger'"
            [state]="(this.stateService.isMobileMenuShown$ | async)"
          ></stusan-toggle-icon>
        </stusan-control-button>
        <stusan-menu-mobile (actionChange)="handleAction($event)"></stusan-menu-mobile>
      </div>
    </div>
  </div>
</div>
